import { useLayoutEffect } from 'react';
import { useThemeStore } from '@/store/useThemeStore';

export default function ThemeProvider({ children }) {
  const initializeTheme = useThemeStore((state) => state.initializeTheme);

  useLayoutEffect(() => {
    initializeTheme();
  }, [initializeTheme]);

  return children;
}
